import type { IEmailFilters } from './types';
import type { ITriggerFieldGroup } from '../WebhookTriggerDialog/types';

/**
 * Email book/integration name in BDK
 */
export const EMAIL_BOOK_NAME = 'email';

/**
 * Email trigger ID for new emails
 */
export const EMAIL_TRIGGER_ID = 'new_email';

/**
 * Email connection ID - same for all users and environments
 */
export const EMAIL_CONNECTION_ID = 'email-book-connection';

/**
 * Integrations that should be excluded from the webhook dialog
 * These integrations have dedicated trigger dialogs (e.g., EmailTriggerDialog)
 */
export const EXCLUDED_APP_NAMES = [EMAIL_BOOK_NAME];

/**
 * Default empty filters
 */
export const DEFAULT_FILTERS: IEmailFilters = {};

/**
 * Default empty trigger field groups (used when API data is not yet available)
 */
export const DEFAULT_TRIGGER_FIELD_GROUPS: ITriggerFieldGroup[] = [];
